import request from '@/utils/request2'

// 登录
export function Login(data) {
  return request({
    url: '/pro/Login',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function GetProject(params) {
  return request({
    url: '/pro/GetProject',
    method: 'get',
    params: params
  })
}
export function GetEmplist(params) {
  return request({
    url: '/pro/GetEmplist',
    method: 'get',
    params: params
  })
}
export function ppro_GetProjectPS(params) {
  return request({
    url: '/pro/ppro_GetProjectPS',
    method: 'get',
    params: params
  })
}
export function setCt_status(params) {
  return request({
    url: '/pro/setCt_status',
    method: 'get',
    params: params
  })
}

export function GetFZRlist(params) {
  return request({
    url: '/pro/GetFZRlist',
    method: 'get',
    params: params
  })
}

export function GetKFlist(params) {
         return request({
           url: '/pro/GetKFlist',
           method: 'get',
           params: params
         })
       }


export function GetFile(params) {
  return request({
    url: '/pro/GetFile',
    method: 'get',
    params: params
  })
}

export function DeleteLocalFile(params) {
  return request({
    url: '/pro/DeleteLocalFile',
    method: 'get',
    params: params
  })
}
export function upLoadCustomFile(data) {
  return request({
    url: '/pro/upLoadCustomFile',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function Edit_tpr_xm_dy_change(data) {
  return request({
    url: '/pro/Edit_tpr_xm_dy_change',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function Query_tpr_xm_dy_change(data) {
  return request({
    url: '/pro/Query_tpr_xm_dy_change',
    method: 'post',
    data
  })
}

export function Edit_tpr_xm_dy(data) {
  return request({
    url: '/pro/Edit_tpr_xm_dy',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function Query_tpr_xm_dy(data) {
  return request({
    url: '/pro/Query_tpr_xm_dy',
    method: 'post',
    data
  })
}
export function check_tpr_xm_dy(data) {
  return request({
    url: '/pro/check_tpr_xm_dy',
    method: 'get',
    params: data
  })
}
export function Copy_tpr_xm_dy(data) {
  return request({
    url: '/pro/Copy_tpr_xm_dy',
    method: 'post',
    data
  })
}

export function Edit_tpr_xm_jd_change(data) {
  return request({
    url: '/pro/Edit_tpr_xm_jd_change',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function Query_tpr_xm_jd_change(data) {
  return request({
    url: '/pro/Query_tpr_xm_jd_change',
    method: 'post',
    data
  })
}

export function Edit_tpr_xm_jd(data) {
  return request({
    url: '/pro/Edit_tpr_xm_jd',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function Query_tpr_xm_jd(data) {
  return request({
    url: '/pro/Query_tpr_xm_jd',
    method: 'post',
    data
  })
}
export function Query_tpr_xm_jddatachange(data) {
  return request({
    url: '/pro/Query_tpr_xm_jddatachange',
    method: 'post',
    data
  })
}
export function check_tpr_xm_jd(data) {
  return request({
    url: '/pro/check_tpr_xm_jd',
    method: 'get',
    params: data
  })
}
export function Edit_tsys_dicvalue(data) {
  return request({
    url: '/pro/Edit_tsys_dicvalue',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function Query_tsys_dicvalue(data) {
  return request({
    url: '/pro/Query_tsys_dicvalue',
    method: 'get',
    params: data
  })
}
export function Query_tsys_dictype(data) {
  return request({
    url: '/pro/Query_tsys_dictype',
    method: 'get',
    params: data
  })
}
export function Copy_tpr_xm_dy_ty(data) {
  return request({
    url: '/pro/Copy_tpr_xm_dy_ty',
    method: 'get',
    params: data
  })
}

export function BirthEdit_tpr_xm_dy(data) {
  return request({
    url: '/pro/BirthEdit_tpr_xm_dy',
    method: 'post',
    data
  })
}

export function BirthEdit_tpr_xm_jd(data) {
  return request({
    url: '/pro/BirthEdit_tpr_xm_jd',
    method: 'post',
    data
  })
}

export function batch_Edit_module(data) {
  return request({
    url: '/pro/batch_Edit_module',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}

export function set_tpr_xm_jd_jdbded(data) {
  return request({
    url: '/pro/set_tpr_xm_jd_jdbded',
    method: 'get',
    params: data
  })
}

export function Edit_tpr_monthMB(data) {
  return request({
    url: '/pro/Edit_tpr_monthMB',
    method: 'post',
    data
    // headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function Query_tpr_monthMB(data) {
  return request({
    url: '/pro/Query_tpr_monthMB',
    method: 'get',
    params: data
  })
}
export function Query_tpr_monthMB_detail(data) {
  return request({
    url: '/pro/Query_tpr_monthMB_detail',
    method: 'get',
    params: data
  })
}
export function GetZhouBaoRp(data) {
  return request({
    url: '/pro/GetZhouBaoRp',
    method: 'get',
    params: data
  })
}
export function GetMBRp(data) {
  return request({
    url: '/pro/GetMBRp',
    method: 'get',
    params: data
  })
}

export function Edit_tpr_meeting(data) {
  return request({
    url: '/pro/Edit_tpr_meeting',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }
  })
}
export function Query_tpr_meeting(data) {
  return request({
    url: '/pro/Query_tpr_meeting',
    method: 'get',
    params: data
  })
}
export function Edit_tpr_erkai(data) {
  return request({
    url: '/pro/Edit_tpr_erkai',
    method: 'post',
    data
  })
}
export function Query_tpr_erkai(data) {
  return request({
    url: '/pro/Query_tpr_erkai',
    method: 'get',
    params: data
  })
}

export function EditUserPwd(data) {
  return request({
    url: '/Home/EditUserPwd',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  })
}


export function Query_tpr_erkaiTotal(data) {
    return request({
      url: '/pro/Query_tpr_erkaiTotal',
      method: 'get',
      params: data
    })
  }
export function Query_tpr_erkaiZB(data) {
         return request({
           url: '/pro/Query_tpr_erkaiZB',
           method: 'get',
           params: data
         })
       }
export function GetKFRp(data) {
         return request({
           url: '/pro/GetKFRp',
           method: 'get',
           params: data
         })
       }


       export function GetBHDlist(data) {
                return request({
                  url: '/pro/GetBHDlist',
                  method: 'get',
                  params: data
                })
              }

       export function UpdateBHD(data) {
                return request({
                  url: '/pro/UpdateBHD',
                  method: 'get',
                  params: data
                })
              }


              export function Edit_tpr_zb(data) {
                       return request({
                         url: '/pro/Edit_tpr_zb',
                         method: 'post',
                         data,
                         headers: {
                           'Content-Type': 'multipart/form-data;charset=UTF-8'
                         }
                       })
                     }
              export function Query_tpr_zb(data) {
                       return request({
                         url: '/pro/Query_tpr_zb',
                         method: 'get',
                         params: data
                       })
                     }

                      export function checkToken(data) {
                               return request(
                                 {
                                   url: '/apicloud/checkToken',
                                   method: 'get',
                                   params: data
                                 },
                                 'http://hyclound.cn'
                               )
                             }